import * as React from "react";
import type { TagResource, TagSetResource } from "client/resources";
import { TagSetContentRow } from "./TagSetContentRow";

const styles = require("../style.less");

interface TagSetContentProps {
    tagSet: TagSetResource;
    tags: TagResource[];
    tenantTagSummaries: Record<string, number>;
}

export const TagSetContent = ({ tagSet, tags, tenantTagSummaries }: TagSetContentProps) => {
    if (tags.length === 0) return null;

    return (
        <>
            <div className={styles.tenantTagRowsOuterContainer} key={tagSet.Id}>
                <h5>{tagSet.Name}</h5>
                {tags.map((tag) => {
                    return <TagSetContentRow tag={tag} tenantTagSummaries={tenantTagSummaries} />;
                })}
            </div>
        </>
    );
};
